import Vue from 'vue';

const success = (response, resolve) => {
  resolve(response.data);
};

const failed = (error, reject) => {
  reject(error);
};

export default data => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`/google_two_factor_auth/${data.user_id}/enable_2fa`, data)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/googleTwoFactorAuthSetup/enabledGoogleTwoFactorAuth.js